<script>
import appConfig from '@src/app.config'
import scrollEvent from '@utils/scroll-animation.js'
import PageHeader from "@components/page-header.vue";
import ModalContainer from "@components/modal-container.vue";
import ModalWindows from "@components/modal-windows.vue";
import Contacts from "@components/contacts.vue";
import MainScreenPagesSection from "@components/sections/main-screen-pages.vue";
import DataPresentationPagesSection from "@components/sections/data-presentation-pages.vue";
import IndustriesSection from "@components/sections/industries.vue";
import ServicesSection from "@components/sections/services.vue";
import HowItWorksSection from "@components/sections/how-it-works.vue";
import InvestmentSection from "@components/sections/investment.vue";
import JustTrySection from "@components/sections/just-try.vue";
import ArticlesSection from "@components/sections/articles.vue";
import QuestionSection from "@components/sections/question.vue";
import FaqSection from "@components/sections/faq.vue";
import DocumentsSection from "@components/sections/documents.vue";
import FullSiteFooter from '@components/full-site-footer.vue'
import CookiesWarning from '@components/elements/cookies-warning.vue'
import Layout from '@layouts/main.vue'
import {mapGetters} from "vuex";

Number.prototype.lead0 = function (n) {
    var nz = "" + this;
    while (nz.length < n) {
        nz = "0" + nz;
    }
    return nz;
};

export default {
    name: 'Citizen',
    page: {
        title: appConfig.citizen.title,
        meta: [{name: 'description', content: appConfig.citizen.description}],
        link: [{ rel: 'canonical', href: appConfig.citizen.canonical }]
    },
    components: {
        PageHeader,
        ModalContainer,
        ModalWindows,
        Contacts,
        MainScreenPagesSection,
        DataPresentationPagesSection,
        IndustriesSection,
        ServicesSection,
        HowItWorksSection,
        InvestmentSection,
        JustTrySection,
        ArticlesSection,
        QuestionSection,
        FaqSection,
        DocumentsSection,
        FullSiteFooter,
        CookiesWarning,
        Layout,
    },
    data() {
        return {
            windowsWidth: window.innerWidth,
            topTitle: 'Цифровой житель',
            topText: 'Оцените спрос на инфраструктуру с помощью данных о профиле, численности и плотности населения',
            slides: [
                '/assets/images/carousels/citizen/1.webp',
                '/assets/images/carousels/citizen/2.webp',
                '/assets/images/carousels/citizen/3.webp',
            ],
            dataPresentationBlocks: [
                'Соц-дем <span>портрет жителей</span>',
                '<span>Дом, работа</span> и другие типы локаций',
                '<span>Места концентрации жителей</span> в разное время суток',
                '<span>Фактические данные и&nbsp;тренды</span> о населении',
            ],
            justTryBlockData: {
                serviceName: 'Оцените возможности Цифрового жителя',
                imgNum: 1,
            },
            services: [
                {
                    title: 'Цифровой туризм',
                    description: 'Повышайте потенциал туристической отрасли, анализируя турпоток в регионе',
                    background: 'tab-tourism',
                    link: 'tourist',
                },
                {
                    title: 'Посещаемость',
                    description: 'Анализ событий и мероприятий, исследуйте посещаемость объектов и территорий, отслеживайте динамику изменений',
                    background: 'tab-visiting',
                    link: 'visiting',
                },
                {
                    title: 'Геоэффект бизнес',
                    description: 'Выбирайте лучшие места для открытия новых точек продаж и развития сети. Сравнивайте и анализируйте трафик и конкурентов',
                    background: 'tab-geo',
                    link: 'business',
                },
            ],
            mobileNavigationBg: false,
            headerLinks: [
                {
                    text: 'Цифровой житель',
                    external: false,
                    link: 'citizen',
                    analyticsLabel: 'cifrovoi_zhitel',
                },
                {
                    text: 'Цифровой туризм',
                    external: false,
                    link: 'tourist',
                    analyticsLabel: 'cifrovoi_turizm',
                },
                {
                    text: 'Посещаемость',
                    external: false,
                    link: 'visiting',
                    analyticsLabel: 'poseschaemost',
                },
                {
                    text: 'Геоэффект бизнес',
                    external: false,
                    link: 'business',
                    analyticsLabel: 'geoeffekt_biznes',
                },
                {
                    text: 'Документация',
                    external: false,
                    link: null,
                    analyticsLabel: 'dokumentaciya',
                },
            ],
        }
    },
    created() {
        window.addEventListener("scroll", scrollEvent);
        window.addEventListener('resize', this.onResize);
    },
    beforeDestroy() {
        window.addEventListener('resize', this.onResize);
        document.body.style.overflow = 'visible';
    },
    computed: {
        ...mapGetters({
            getActiveModalWindow: 'modal/getActiveModalWindow',
        }),
        isMobile() {
            return this.windowsWidth <= 1000;
        }
    },
    methods: {
        onResize() {
            this.windowsWidth = window.innerWidth;
        },
    },
}
</script>

<template>
    <Layout class="landing-page">
        <PageHeader
            :links="headerLinks"
            :logo-link="false"
            :is-mobile="isMobile"
            :show-login-button="true"
        />

<!--        <ModalContainer />-->

        <ModalWindows
            :open-window="getActiveModalWindow"
        />

        <Contacts />

        <div id="main-page" class="city-map">
            <MainScreenPagesSection
                :title="topTitle"
                :text="topText"
                :slides="slides"
            />

            <DataPresentationPagesSection
                :blocks="dataPresentationBlocks"
                :block-minimal-width-tablet="276"
            />
        </div>

        <IndustriesSection  />

        <ServicesSection :services="services" />

        <HowItWorksSection  />

<!--        <InvestmentSection />-->

        <JustTrySection
            :service-name="justTryBlockData.serviceName"
            :img-num="justTryBlockData.imgNum"

        />

        <ArticlesSection />

        <QuestionSection  />

        <FaqSection />

        <DocumentsSection  />

        <CookiesWarning />
    </Layout>
</template>

<style lang="scss">
    @import '@design/components/header.scss';
    @import '@design/components/full-site-footer.scss';
    @import '@design/landing.scss';
</style>

